import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../landing/components/HeroSection';
import ProductSelectionSection from '../landing/components/ProductSelectionSection';
import SupplySelectionSection from '../landing/components/SupplySelectionSection';
import DeliverySection from '../landing/components/DeliverySection';
import SetupSection from '../landing/components/SetupSection';
import TeamCollaborationSection from '../landing/components/TeamCollaborationSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ProductSelectionSection />
      <SupplySelectionSection />
      <DeliverySection />
      <SetupSection />
      <TeamCollaborationSection />
      <Footer />
    </div>
  );
}
